import ArticleLayout from '@/components/feature/ArticleLayout';
import { reviewArticle } from '@/mocks/reviewArticle';

export default function HipobuySpreadsheetReview() {
  return <ArticleLayout article={reviewArticle} slug="hipobuy-spreadsheet-review" />;
}